export const STORAGE_KEYS = {
  EncryptedSeedAndMnemonic: 'encryptedSeedAndMnemonic',
};
